import { c as _c } from "react/compiler-runtime";
import { Map, MapControls, MapMarker, MarkerContent, MarkerTooltip, useMap } from "@repo/ui/components/map";
import * as maplibregl from "maplibre-gl";
import { Protocol } from "pmtiles";
import layers from "protomaps-themes-base";
import { useEffect, useMemo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PMTILES_URL = "pmtiles://https://uploads.fasterforward.se/tiles/sweden.pmtiles";
const STATUS_COLORS = {
  approved: "#22c55e",
  pending: "#f59e0b",
  under_review: "#3b82f6",
  rejected: "#9ca3af"
};
let pmtilesRegistered = false;
function ensurePmtilesProtocol() {
  if (pmtilesRegistered) return;
  maplibregl.addProtocol("pmtiles", new Protocol().tile);
  pmtilesRegistered = true;
}

/** Raycasting point-in-polygon test */
function pointInRing(point, ring) {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    if (yi > point[1] !== yj > point[1] && point[0] < (xj - xi) * (point[1] - yi) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
}

/** Extract the single polygon from a MultiPolygon that contains the given point */
function extractContainingPolygon(geometry, point) {
  if (geometry.type === "Polygon") {
    if (pointInRing(point, geometry.coordinates[0])) {
      return geometry;
    }
    return null;
  }
  if (geometry.type === "MultiPolygon") {
    for (const coords of geometry.coordinates) {
      if (pointInRing(point, coords[0])) {
        return {
          type: "Polygon",
          coordinates: coords
        };
      }
    }
  }
  return null;
}
export function PlaceMiniMap(t0) {
  const $ = _c(35);
  const {
    latitude,
    longitude,
    features,
    onFeatureClick
  } = t0;
  ensurePmtilesProtocol();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = layers("protomaps", "light", "en").filter(_temp);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const baseLayers = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      light: {
        version: 8,
        glyphs: "https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf",
        sources: {
          protomaps: {
            type: "vector",
            url: PMTILES_URL,
            attribution: "<a href=\"https://protomaps.com\">Protomaps</a> | <a href=\"https://openstreetmap.org\">OSM</a>"
          }
        },
        layers: baseLayers
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const styles = t2;
  const t3 = longitude - 0.005;
  const t4 = latitude - 0.003;
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = [t3, t4];
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = longitude + 0.005;
  const t7 = latitude + 0.003;
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = [t6, t7];
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5 || $[9] !== t8) {
    t9 = [t5, t8];
    $[8] = t5;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const maxBounds = t9;
  let t10;
  if ($[11] !== latitude || $[12] !== longitude) {
    t10 = [longitude, latitude];
    $[11] = latitude;
    $[12] = longitude;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = /*#__PURE__*/_jsx(MapControls, {
      position: "top-right",
      showZoom: true
    });
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== latitude || $[16] !== longitude) {
    t12 = /*#__PURE__*/_jsx(BuildingExtrusion, {
      latitude: latitude,
      longitude: longitude
    });
    $[15] = latitude;
    $[16] = longitude;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== latitude || $[19] !== longitude) {
    t13 = {
      latitude,
      longitude
    };
    $[18] = latitude;
    $[19] = longitude;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== features || $[22] !== t13) {
    t14 = /*#__PURE__*/_jsx(FitBoundsOnce, {
      center: t13,
      features: features
    });
    $[21] = features;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== features || $[25] !== onFeatureClick) {
    let t16;
    if ($[27] !== onFeatureClick) {
      t16 = f => {
        const color = STATUS_COLORS[f.status] ?? "#94a3b8";
        return /*#__PURE__*/_jsxs(MapMarker, {
          longitude: f.longitude,
          latitude: f.latitude,
          onClick: () => onFeatureClick?.(f.id),
          children: [/*#__PURE__*/_jsx(MarkerContent, {
            children: /*#__PURE__*/_jsx("div", {
              className: "flex h-[26px] w-[26px] cursor-pointer items-center justify-center rounded-full border-[2.5px] border-white text-[11px] font-bold text-white shadow-[0_2px_6px_rgba(0,0,0,0.35)] transition-transform duration-150 ease-out hover:scale-125",
              style: {
                background: color
              },
              children: f.label.charAt(0)
            })
          }), /*#__PURE__*/_jsx(MarkerTooltip, {
            className: "ffw-tooltip",
            children: f.label
          })]
        }, f.id);
      };
      $[27] = onFeatureClick;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    t15 = features.map(t16);
    $[24] = features;
    $[25] = onFeatureClick;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[29] !== maxBounds || $[30] !== t10 || $[31] !== t12 || $[32] !== t14 || $[33] !== t15) {
    t16 = /*#__PURE__*/_jsx("div", {
      className: "h-full w-full",
      "data-vaul-no-drag": true,
      children: /*#__PURE__*/_jsxs(Map, {
        styles: styles,
        center: t10,
        zoom: 17,
        minZoom: 15,
        maxZoom: 20,
        pitch: 45,
        maxBounds: maxBounds,
        attributionControl: false,
        className: "rounded-lg",
        children: [t11, t12, t14, t15]
      })
    });
    $[29] = maxBounds;
    $[30] = t10;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}

/** Adds a 3D extrusion of the building containing the given point. */
function _temp(l) {
  return l.id !== "buildings";
}
function BuildingExtrusion(t0) {
  const $ = _c(6);
  const {
    latitude,
    longitude
  } = t0;
  const {
    map,
    isLoaded
  } = useMap();
  let t1;
  let t2;
  if ($[0] !== isLoaded || $[1] !== latitude || $[2] !== longitude || $[3] !== map) {
    t1 = () => {
      if (!isLoaded || !map) {
        return;
      }
      map.addLayer({
        id: "buildings-query",
        source: "protomaps",
        "source-layer": "buildings",
        type: "fill",
        paint: {
          "fill-opacity": 0.01
        }
      });
      const onIdle = () => {
        const point = map.project([longitude, latitude]);
        const hits = map.queryRenderedFeatures(point, {
          layers: ["buildings-query"]
        });
        if (map.getLayer("buildings-query")) {
          map.removeLayer("buildings-query");
        }
        const building = hits[0];
        if (!building) {
          return;
        }
        const singlePolygon = extractContainingPolygon(building.geometry, [longitude, latitude]);
        if (!singlePolygon) {
          return;
        }
        map.addSource("place-building", {
          type: "geojson",
          data: {
            type: "Feature",
            properties: building.properties ?? {},
            geometry: singlePolygon
          }
        });
        map.addLayer({
          id: "place-building-3d",
          source: "place-building",
          type: "fill-extrusion",
          paint: {
            "fill-extrusion-color": "#0d9488",
            "fill-extrusion-height": building.properties?.height || 10,
            "fill-extrusion-opacity": 0.4
          }
        });
      };
      map.once("idle", onIdle);
      return () => {
        try {
          if (map.getLayer("place-building-3d")) {
            map.removeLayer("place-building-3d");
          }
          if (map.getSource("place-building")) {
            map.removeSource("place-building");
          }
          if (map.getLayer("buildings-query")) {
            map.removeLayer("buildings-query");
          }
        } catch {}
      };
    };
    t2 = [isLoaded, map, latitude, longitude];
    $[0] = isLoaded;
    $[1] = latitude;
    $[2] = longitude;
    $[3] = map;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
}
function FitBoundsOnce({
  center,
  features
}) {
  const {
    map,
    isLoaded
  } = useMap();
  useEffect(() => {
    if (!isLoaded || !map) return;
    if (features.length <= 1) return;
    const bounds = new maplibregl.LngLatBounds();
    bounds.extend([center.longitude, center.latitude]);
    for (const f of features) {
      bounds.extend([f.longitude, f.latitude]);
    }
    map.fitBounds(bounds, {
      padding: 40,
      maxZoom: 19
    });
    // Intentionally only on initial map load — subsequent feature changes
    // should not re-fit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, map]);
  return null;
}